<div class="fixed inset-0 flex items-center justify-center bg-black/40 z-[11000]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="assign-popup-title"
      (click)="close.emit(null)">
      <div class="bg-white rounded-[16px] border border-[#E4E6E8] w-[820px] max-w-[95vw] max-h-[90vh] flex flex-col overflow-hidden"
           (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="flex flex-wrap items-center gap-x-3 gap-y-2 sm:gap-4 px-4 sm:px-6 pt-4 sm:pt-6 pb-4 flex-shrink-0">
          <button type="button" (click)="close.emit(null)" class="flex-shrink-0 order-1">
            <img src="assets/icons/backward-arrow.svg" alt="Back" class="w-5 h-5 sm:w-auto sm:h-auto" />
          </button>
          <h2 class="text-[20px] sm:text-[28px] font-bold text-[#192A3E] flex-1 min-w-0 leading-tight order-2">{{ title }}</h2>
          <button type="button" (click)="close.emit(null)" class="flex-shrink-0 order-3">
            <img src="assets/icons/dialog-cancel.svg" alt="close" />
          </button>
          <p-iconfield iconPosition="left" class="w-full sm:w-[170px] order-4">
          <p-inputicon>
            <img src="assets/icons/search.svg" width="16" />
          </p-inputicon>
          <input
            type="text"
            pInputText
            placeholder="Search"
            class="w-full !rounded-full !border-[#D9DDE2] !bg-white !text-[13px] !text-[#192A3E]"
            [value]="providerSearch()"
            (input)="providerSearch.set($any($event.target).value)"
          />
        </p-iconfield>
        </div>

        <!-- Grid -->
        <div class="flex-1 overflow-y-auto px-4 sm:px-6 pb-6" (scroll)="onScroll($event)">
          @if (isLoading()) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              @for (i of [1,2,3,4,5,6]; track i) {
                <div class="flex items-center gap-[14px] border border-[#E8ECEF] rounded-[10px] px-4 py-[14px] animate-pulse">
                  <div class="w-[52px] h-[52px] rounded-full bg-[#D6D8DB] flex-shrink-0"></div>
                  <div class="flex-1">
                    <div class="w-28 h-3.5 bg-[#D6D8DB] rounded mb-2"></div>
                    <div class="w-20 h-3 bg-[#D6D8DB] rounded"></div>
                  </div>
                </div>
              }
            </div>
          } @else if (filteredList().length === 0) {
            <div class="flex items-center justify-center py-16">
              <span class="text-sm text-[#757A80]">No results found.</span>
            </div>
          } @else {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              @for (item of filteredList(); track item.user_id) {
                <div class="flex items-center gap-[14px] border border-[#E8ECEF] rounded-[10px] px-4 py-[14px]">
                  @if (getAvatar(item); as avatar) {
                    <div class="relative w-[52px] h-[52px] rounded-full overflow-hidden flex-shrink-0">
                      <img [src]="avatar" [alt]="getDisplayName(item)"
                           [class.blur-sm]="isPictureBlocked(item.profile_picture_moderation_status)"
                           class="w-full h-full object-cover" />
                      @if (isPictureBlocked(item.profile_picture_moderation_status)) {
                      <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-5 h-5 pointer-events-none" />
                      }
                    </div>
                  } @else {
                    <div class="w-[52px] h-[52px] rounded-full bg-[#2E7FBE] flex items-center justify-center text-white text-lg font-bold flex-shrink-0">
                      {{ getInitials(item) }}
                    </div>
                  }
                  <div class="flex-1 min-w-0">
                    <div class="flex items-center gap-[6px] flex-wrap mb-[3px]">
                      <span class="text-[14px] font-bold text-[#192A3E] truncate">{{ getDisplayName(item) }}</span>
                      @if (item.is_verified) {
                        <span class="flex items-center gap-[3px] bg-[#2AACA8] text-white text-[10px] font-semibold px-[7px] py-[2px] rounded-full flex-shrink-0">
                          <img src="assets/icons/check.svg" alt="" class="w-[10px] h-[10px] brightness-0 invert" />Verified
                        </span>
                      }
                    </div>
                    <div class="text-[12px] text-[#6B7280] truncate leading-5">{{ getLocation(item) }}</div>
                  </div>
                  <button type="button" class="flex-shrink-0" (click)="selectItem(item)">
                    @if (multiSelect && isSelected(item)) {
                      <div class="w-6 h-6 rounded-full bg-[#2E7FBE] flex items-center justify-center flex-shrink-0">
                        <img src="assets/icons/check.svg" alt="selected" class="w-3 h-3 brightness-0 invert" />
                      </div>
                    } @else {
                      <img src="assets/icons/add-collab.svg" alt="select" />
                    }
                  </button>
                </div>
              }
            </div>
          }

          @if (isLoadingMore()) {
            <div class="flex justify-center py-4">
              <div class="w-6 h-6 border-2 border-[#238EC6] border-t-transparent rounded-full animate-spin"></div>
            </div>
          }
        </div>

        @if (multiSelect) {
          <div class="px-6 py-4 border-t border-[#EBEFF2] flex-shrink-0">
            <button type="button"
              class="w-full py-3 rounded-[10px] bg-[#192A3E] text-white font-semibold text-base disabled:opacity-40 transition"
              [disabled]="selectedItems().length === 0"
              (click)="confirmSelection()">
              Add {{ selectedItems().length > 0 ? selectedItems().length + ' ' : '' }}Guest{{ selectedItems().length !== 1 ? 's' : '' }}
            </button>
          </div>
        }

      </div>
    </div>